/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DeliveryZoneResponse } from '../models/delivery-zone-response';
import { DeliveryZonesCollectionResponse } from '../models/delivery-zones-collection-response';
import { deliveryZonesGetAll } from '../fn/stores-delivery-zones/delivery-zones-get-all';
import { DeliveryZonesGetAll$Params } from '../fn/stores-delivery-zones/delivery-zones-get-all';
import { deliveryZonesPost } from '../fn/stores-delivery-zones/delivery-zones-post';
import { DeliveryZonesPost$Params } from '../fn/stores-delivery-zones/delivery-zones-post';
import { deliveryZonesPut } from '../fn/stores-delivery-zones/delivery-zones-put';
import { DeliveryZonesPut$Params } from '../fn/stores-delivery-zones/delivery-zones-put';

@Injectable({ providedIn: 'root' })
export class StoresDeliveryZonesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deliveryZonesGetAll()` */
  static readonly DeliveryZonesGetAllPath = '/stores/{storeId}/delivery-zones';

  /**
   * Gets Delivery Zones of a specified store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryZonesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryZonesGetAll$Response(params: DeliveryZonesGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryZonesCollectionResponse>> {
    return deliveryZonesGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets Delivery Zones of a specified store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryZonesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryZonesGetAll(params: DeliveryZonesGetAll$Params, context?: HttpContext): Observable<DeliveryZonesCollectionResponse> {
    return this.deliveryZonesGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeliveryZonesCollectionResponse>): DeliveryZonesCollectionResponse => r.body)
    );
  }

  /** Path part for operation `deliveryZonesPost()` */
  static readonly DeliveryZonesPostPath = '/stores/{storeId}/delivery-zones';

  /**
   * Add Delivery Zone for a specified store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryZonesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryZonesPost$Response(params: DeliveryZonesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryZoneResponse>> {
    return deliveryZonesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Delivery Zone for a specified store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryZonesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryZonesPost(params: DeliveryZonesPost$Params, context?: HttpContext): Observable<DeliveryZoneResponse> {
    return this.deliveryZonesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeliveryZoneResponse>): DeliveryZoneResponse => r.body)
    );
  }

  /** Path part for operation `deliveryZonesPut()` */
  static readonly DeliveryZonesPutPath = '/stores/{storeId}/delivery-zones/{zoneId}';

  /**
   * Updates specified Delivery Zone.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryZonesPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryZonesPut$Response(params: DeliveryZonesPut$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryZoneResponse>> {
    return deliveryZonesPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates specified Delivery Zone.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryZonesPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryZonesPut(params: DeliveryZonesPut$Params, context?: HttpContext): Observable<DeliveryZoneResponse> {
    return this.deliveryZonesPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeliveryZoneResponse>): DeliveryZoneResponse => r.body)
    );
  }

}
